import React from 'react'
import { TimePicker } from 'antd';
import dayjs from 'dayjs';

const AntDTimePicker = ({
    value,
    defaultValue,
    onChange,
    format, // format="h:mm a" for 12 hours format
    placeholder = "--:--", // placeholder="Select time" or any text
    disabled , // disabled={true} or false
    use12Hours, // use12Hours={true} or false
    hourStep = 1, // hourStep={1} or any number
    minuteStep = 1, // minuteStep={1} or any number
    hideDisabledOptions, // hideDisabledOptions={true} or false
    disabledTime,
    allowClear , // allowClear={true} or false
    showNow, 
    name,
    ...rest
}) => {
  return (
    <div className='SwAntDPicker'>
    <TimePicker 
        name={name}
        value={value ? dayjs(value) : undefined}
        defaultValue={defaultValue}
        onChange={onChange}
        format={format}
        placeholder={placeholder}
        disabled={disabled}
        use12Hours={use12Hours}
        hourStep={hourStep}
        minuteStep={minuteStep}
        hideDisabledOptions={hideDisabledOptions}
        disabledTime={disabledTime}
        allowClear={allowClear}
        showNow={showNow}
        {...rest}
    />
  </div>
  )
}

export default AntDTimePicker
 